import { StepWizardStep } from '../../../commons/StepWizard/StepWizard.types';
import CreateConsultFirstStep from './CreateConsultFirstStep/CreateConsultFirstStep';
import CreateConsultFirstStepForm from './CreateConsultFirstStep/CreateConsultFirstStepForm/CreateConsultFirstStepForm';
import CreateConsultForthStep from './CreateConsultForthStep/CreateConsultForthStep';
import CreateConsultSecondStep from './CreateConsultSecondStep/CreateConsultSecondStep';
import CreateConsultThirdStep from './CreateConsultThirdStep/CreateConsultThirdStep';
import { CreateConsultSteps, CreateConsultStepsData } from './CreateConsultationSteps.types';
import 'react-calendar/dist/Calendar.css';

export const newCreateConsultSteps: StepWizardStep[] = [
  {
    step: 1,
    component: CreateConsultFirstStepForm,
    title: 'Informations de base',
    subtitle: 'Renseignez les informations de base de la consultation',
  },
  {
    step: 2,
    component: CreateConsultSecondStep,
    title: 'Contenu',
    subtitle: 'Description détaillée de vos besoins',
  },
  {
    step: 3,
    component: CreateConsultThirdStep,
    title: 'Dates',
    subtitle: "Période d'actvité de la consultation",
  },
  {
    step: 4,
    component: CreateConsultForthStep,
    title: 'Résumé',
    subtitle: 'Résumé de votre consultation',
  },
];

export const createConsultSteps = Object.freeze<CreateConsultStepsData>({
  [CreateConsultSteps.First]: {
    component: CreateConsultFirstStep,
  },
  [CreateConsultSteps.Second]: {
    component: CreateConsultSecondStep,
  },
  [CreateConsultSteps.Third]: {
    component: CreateConsultThirdStep,
  },
  [CreateConsultSteps.Forth]: {
    component: CreateConsultForthStep,
  },
});
